import { useFormikContext } from "formik";
import React from "react";
import Col from "react-bootstrap/esm/Col";
import Row from "react-bootstrap/esm/Row";
import Button from "react-bootstrap/esm/Button";
import { Link } from "react-router-dom";
import { Spinner } from "react-bootstrap";

export const Verify2faEmailSubmission = ({ submitted }) => {
    const { isSubmitting, status } = useFormikContext(); // use to disable button while the request is being made to server and to check for successful api call

    let statusMessage = "";

    if (status?.error === true) {
        statusMessage = (
            <p role="status" className="text-danger">Error with verifying phone number. Please Try again</p>
        );
    } else if (status?.error === false) {
        statusMessage = (
            <>
                <Row>
                    <p role="status" className="text-success">
                        Your 2FA email has been verified. Redirecting back to security settings 
                    </p>
                </Row>
                <Row className="text-success">
                    <Spinner  animation="border" role="status">
                    {/* <span className="visually-hidden">Loading...</span> */}
                    </Spinner> Redirecting...      
                </Row>
            </>
        );
    } else {
        statusMessage = "";
    }

    return (
        <>
            <Row>{statusMessage}</Row>
            {!submitted && (
                <>
                    <Row>
                        <Col>
                            <Button
                                className="btn btn-primary"
                                type="submit"
                                disabled={isSubmitting}
                            >
                                Submit
                            </Button>
                        </Col>
                    </Row>
                </>
            )}
        </>
    );
};
